/**
 * Videos
 * ======================================
 * - play videos in viewport
 * - pause videos outside viewport
 */

 const ELEMENTS = '.js-videos'
 const SCROLL_EL = '.jumbo-video'

 class VideosAutoscroll {
   constructor() {
    const canvas = document.querySelector('.jumbo-video')

    if(!canvas) {
      return
    }

     this.sections = document.querySelectorAll(ELEMENTS)

     window.addEventListener('scroll', this.removeAction, false)
     canvas.addEventListener('scroll', this.removeAction, false)

     this.playHandler()
   }

   removeAction = () => {

   }

   playHandler = () => {
     for (const section of this.sections) {
       const video = section.querySelector('video')

       video.addEventListener('ended', function() {
        const nextSection = section.nextElementSibling
        const nextSectionIndex = nextSection.getAttribute('data-index') - 1

        document.querySelector(SCROLL_EL).scroll({
          top: nextSection.getBoundingClientRect().height * nextSectionIndex,
          behavior: 'smooth'
        })

        this.play()
       }, false)
     }
   }
 }

 new VideosAutoscroll()
